<template>
    <BasePanel 
        headline="lang_GENERAL_PANEL_CAPTION_SPLITS"
        :alvqa="alvqa"
    >            
        <template v-slot:panelContent>
            <v-data-table
                class="baseInlineEditingDataTable"
                :headers="headers"
                :items="items"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :loading="isLoading"
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                :items-per-page="itemsPerPage"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.rights`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-rights'">
                        {{ $t(getTypeOfRights(item.rights)) }}
                    </div>
                </template>
                <template v-slot:[`item.split`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-split'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.split, 'number') }}
                    </div>
                </template>    
                <template v-slot:[`item.base`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-base'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.base, 'number') }}
                    </div>
                </template>  
                <template v-slot:[`item.applyTo`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-apply-to'">
                        {{ $t(getApplyTo(item.applyTo)) }}
                    </div>
                </template>
                <template v-slot:[`item.region`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-region'">
                        {{ $alvPlugin.createRegionsToString(item.region) }}
                    </div>
                </template>

                <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteSplitsRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-' + item.id + '-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseInlineEditingDataTable from "@/components/_base/BaseInlineEditingDataTable"
import BaseButton from '@/components/_buttons/BaseButton'

import { DropdownContractsPublishingApplyTo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "PublishingContractsSplitsEditPanel",  
    components: { 
        BasePanel,
        BaseIcon,
        BaseInlineEditingDataTable,
        BaseButton
    },
    data() {
        return {
            alvqa: 'contracts-publishing-edit-form-panel-splits'
        }
    },
    computed: {
        items() { 
            this.$store.commit('setIsLoading', true)
            this.$store.dispatch('fetchPublishingContractSplits')
            return this.$store.getters.getPublishingContractSplits 
        },

        isLoading() { return this.$store.getters.getIsLoading },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },

		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */
        headers() {
            return [
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_RIGHTS"),
                    value: "rights",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-rights'
                },
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_BASE"),
                    value: "base",
                    align: "right",
                    width: "105px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-base'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_SPLIT"),
                    value: "split",  
                    align: "right",
                    width: "105px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-split'
                },
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_REGION"),
                    value: "region",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-region'
                },
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_APPLY_TO"),
                    value: "applyTo",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-apply-to'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        }
    },
    methods: {
        addNewRow(){
            this.$store.commit('setShowEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultPublishingContractSplits)) 
            this.$store.commit('setPublishingContractSplitsEditingDialogDetails', defaultValues)
        }, 
        getApplyTo(applyToValue) {
            let applyToValues = DropdownContractsPublishingApplyTo
            if(applyToValue === null) return ''
            else {
                let applyToMatch =  applyToValues.find(applyTo => {
                    return applyTo.value === applyToValue
                })

                if(applyToMatch !== undefined) return applyToMatch.text
            }
        },

        // "Rights" Dropdown Items for Splits Editing Dialog
        getTypeOfRights(typeValue) { 
            let rights = this.$store.getters.getPublishingContractTypeOfRights

            if(rights === null) return ''
            else {
                let match = rights.find(right => {
                    return right.value === typeValue
                })

                if(match !== undefined) return match.text
            }
        },

        regionsIncludeExcludeFormatted(region) {
            let regions = ''

            if(region.include.length !== 0)  {
                let includes = region.include.join('+')
                regions += includes
            }
            if(region.exclude.length !== 0) {
                regions += '-'
                let excludes = region.exclude.join('-')
                regions += excludes
            }
            return regions
        },
        deleteSplitsRow(item){ 
            this.$store.commit("setSelectedPublishingContractSplits", [item.id])
            this.$store.commit('setDeletionDialogContext', 'SelectedPublishingContractSplits')
            this.$store.commit('setShowDeletionDialog', true)
        },
        editInlineFunction(item) {
            this.$store.commit('setSelectedPublishingContractSplits', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // formatting numbers to show in correct notation
            detailsDeepCopy['base'] = this.$alvPlugin.getNumberLocalization(detailsDeepCopy['base'], 'number')
            detailsDeepCopy['split'] = this.$alvPlugin.getNumberLocalization(detailsDeepCopy['split'], 'number')

            // set the copy in dialog details to edit
            this.$store.commit('setPublishingContractSplitsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowEditingDialog', true) 
        }
    }
}
</script>

<style>
  .baseInlineEditingDataTable table {
    table-layout: fixed;
  }
  .baseInlineEditingDataTable table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>